import React from 'react';
import ErrorScreen from '../screens/ErrorScreen';

export default class ErrorBoundary extends React.Component {
  state = { hasError: false };
  static getDerivedStateFromError() { return { hasError: true }; }

  handleError = event => {
    // Browser extensions are outside the application and must not disable it.
    const source = event.filename || event.error?.stack || event.reason?.stack || '';
    if (/chrome-extension:\/\/|moz-extension:\/\//i.test(source)) return;
    // Resource load failures (e.g. a missing image) are not JavaScript crashes.
    if (event.type === 'error' && !event.error && !event.message) return;
    this.setState({ hasError: true });
  };

  componentDidMount() {
    if (!this.props.global) return;
    window.addEventListener('error', this.handleError);
    window.addEventListener('unhandledrejection', this.handleError);
    window.addEventListener('practidex:unexpected-error', this.handleError);
  }
  componentWillUnmount() {
    if (!this.props.global) return;
    window.removeEventListener('error', this.handleError);
    window.removeEventListener('unhandledrejection', this.handleError);
    window.removeEventListener('practidex:unexpected-error', this.handleError);
  }
  componentDidUpdate(_, previousState) {
    if (this.state.hasError && !previousState.hasError) window.scrollTo(0, 0);
  }
  render() {
    return this.state.hasError ? <ErrorScreen /> : this.props.children;
  }
}
